import { getOauthToken, getCareAuthToken } from "./utils1";
import axios from "@/axiosInterceptor";
import {
  BC_API_BASE_URL,
  CARE_MW_API_BASE_URL,
  BC_API_BASE_URL_WD,
} from "@/apiConfig";

// this function get items frm BC or cache

export async function getItems() {
  let items = [];
  try {
    const response = await axios.get(BC_API_BASE_URL + `/items`, {
      headers: { Authorization: `Bearer ${getOauthToken()}` },
    });
    items = response.data.value;

    // Fetch images for each item (if applicable)
    for (let item of items) {
      try {
        const imageResponse = await axios.get(
          BC_API_BASE_URL + `/items(${item.id})/picture/pictureContent`,
          {
            responseType: "blob", // Set response type to 'blob' to handle binary data
            headers: { Authorization: `Bearer ${getOauthToken()}` },
          }
        );

        if (
          typeof imageResponse.data === "string" &&
          imageResponse.data.includes("base64")
        ) {
          item.image = imageResponse.data;
        } else {
          const url = URL.createObjectURL(imageResponse.data); // Create a URL from the Blob data
          item.image = url;
        }
      } catch (imageError) {
        console.error(`Failed to fetch image for item ${item.id}`, imageError);
        item.image = "https://via.placeholder.com/150"; // Set a placeholder if image fetch fails
      }
    }
  } catch (error) {
    console.error("Error fetching items:", error);
    throw error; // Rethrow the error to be handled by the calling function
  }
  console.log(items);
  return items; // Return items outside the finally block
}

// get customers from BC to cahce
export async function getCustomers() {
  let customers = [];
  try {
    const response = await axios.get(`${BC_API_BASE_URL}/customers`, {
      headers: {
        Authorization: `Bearer ${getOauthToken()}`,
        "Content-Type": "application/json", // Explicitly set Content-Type
      },
    });

    console.log(response.data.value);
    customers = response.data.value;

    // Fetch images for each customer (if applicable)
    for (let customer of customers) {
      // Example of calling a separate API for images based on customer.id

      try {
        const imageResponse = await axios.get(
          BC_API_BASE_URL + `/customers(${customer.id})/picture/pictureContent`,
          {
            responseType: "blob", // Set response type to 'blob' to handle binary data
            headers: { Authorization: `Bearer ${getOauthToken()}` },
          }
        );

        if (
          typeof imageResponse.data === "string" &&
          imageResponse.data.includes("base64")
        ) {
          customer.image = imageResponse.data;
        } else {
          const url = URL.createObjectURL(imageResponse.data); // Create a URL from the Blob data
          customer.image = url;
        }
      } catch (imageError) {
        console.error(
          `Failed to fetch image for customer ${customer.id}`,
          imageError
        );
        customer.image = "https://via.placeholder.com/150"; // Set a placeholder if image fetch fails
      }
    }
  } catch (error) {
    console.error("Error fetching customers:", error);
    throw error;
  }
  return customers;
}

export async function getQuotesFromBC() {
  let quotes = [];
  try {
    const response = await axios.get(`${BC_API_BASE_URL}/salesquotes`, {
      headers: {
        Authorization: `Bearer ${this.getOauthToken()}`,
        "Content-Type": "application/json", // Explicitly set Content-Type
      },
    });

    console.log(response.data.value);
    quotes = response.data.value;
  } catch (error) {
    console.error("Error fetching quotes:", error);
    throw error;
  }
  return quotes;
}

function getImageDataFromLocalStorage(imageID) {
  const imgURL = BC_API_BASE_URL + `/items(${imageID})/picture/pictureContent`;
  console.log(imgURL);
  return localStorage.getItem(imgURL);
}

function populateImageData(quotesIn) {
  const quotes = quotesIn;
  for (var i = 0; i < quotes.length; i++) {
    for (var j = 0; j < quotes[i].items.length; j++) {
      console.log(quotes[i].items[j]);
      quotes[i].items[j].image = getImageDataFromLocalStorage(
        quotes[i].items[j].id
      );
    }
  }
  return quotes;
}

export async function delQuoteFromCareDB(quoteid) {
  try {
    await axios.delete(`${CARE_MW_API_BASE_URL}/quote/${quoteid}`, {
      headers: {
        Authorization: `Bearer ${getCareAuthToken()}`,
        "Content-Type": "application/json", // Explicitly set Content-Type
      },
      cache: false, // Disable cache for this request
    });
  } catch (error) {
    console.error("Error fetching quotes:", error);
    throw error;
  }
}

export async function submitQuoteToBC(quote) {
  try {
    // creat the basic quote in bc
    let basic_quote = {};
    console.log("submitQuoteToBC1");
    basic_quote.customerId = quote.customerid;
    basic_quote.salesperson = quote.salesperson;

    const response = await axios.post(
      BC_API_BASE_URL + `/salesQuotes`,
      basic_quote,
      {
        headers: {
          Authorization: `Bearer ${getOauthToken()}`,
          "Content-Type": "application/json", // Explicitly set Content-Type
        },
      }
    );
    console.log(response.data.id);
    const sales_quote_id = response.data.id;
    // done creating the basic quote in bc

    // now update the work desc
    try {
      const wd = new Blob([quote.workdescription], { type: "text/plain" }); // Create the blob
      console.log(quote.workdescription);
      const response = await axios.patch(
        BC_API_BASE_URL_WD +
          `/salesDocuments(${sales_quote_id})/workDescription`,
        wd,
        {
          headers: {
            Authorization: `Bearer ${getOauthToken()}`,
            "If-Match": "*", // Add the If-Match header with wildcard
            "Content-Type": "text/plain",
          },
        }
      );
      console.log(response);
    } catch (error) {
      console.error("Error updating work desc", error);
      throw error; // Rethrow the error to be handled by the calling function
    }
    // done update the work desc to quote

    // now add the items to quote
    try {
      console.log("for0");
      for (let i = 0; i < quote.items.length; i++) {
        console.log("for1");
        let item_in = {};
        item_in.itemId = quote.items[i].id;
        item_in.quantity = quote.items[i].quantity;
        console.log(item_in);
        const response = await axios.post(
          BC_API_BASE_URL + `/salesQuotes(${sales_quote_id})/salesQuoteLines`,
          item_in,
          {
            headers: {
              Authorization: `Bearer ${getOauthToken()}`,
              "Content-Type": "application/json", // Explicitly set Content-Type
            },
          }
        );
        console.log(response);
      }
    } catch (error) {
      console.error("Error updating work desc", error);
      throw error; // Rethrow the error to be handled by the calling function
    }
    // done with add items to quote

    // now sice it has succeeded this far. change the submitted flag in CARE db to 1 so that its readonly now on
    try {
      const qt_data = {};
      qt_data.submitted = 1;
      await axios.put(`${CARE_MW_API_BASE_URL}/quote/${quote.id}`, qt_data, {
        headers: {
          Authorization: `Bearer ${getCareAuthToken()}`,
          "Content-Type": "application/json", // Explicitly set Content-Type
        },
      });
    } catch (error) {
      console.error(error);
      throw error;
    }
    // done with changing submitted flag to true.
  } catch (error) {
    console.error("Error adding quote items:", error);
    throw error; // Rethrow the error to be handled by the calling function
  }
}

export async function getQuotesFromCareDB() {
  let quotes = [];
  try {
    const response = await axios.get(`${CARE_MW_API_BASE_URL}/quotes`, {
      headers: {
        Authorization: `Bearer ${getCareAuthToken()}`,
        "Content-Type": "application/json", // Explicitly set Content-Type
      },
      cache: false, // Disable cache for this request
    });
    // populate image data from localstorage
    console.log("quotes before populateImageData");
    console.log(response.data);
    quotes = populateImageData(response.data);
    console.log("quotes after populateImageData");
    console.log(quotes);
  } catch (error) {
    console.error("Error fetching quotes:", error);
    throw error;
  }
  return quotes;
}

function removeImageFromItems(quote_in) {
  // Check if the input JSON has an items array
  const quote = JSON.parse(JSON.stringify(quote_in));
  if (quote && Array.isArray(quote.items)) {
    // Iterate through each item and delete the 'image' property
    quote.items.forEach((item) => {
      delete item.image;
    });
  }
  return quote; // Return the modified JSON object
}

export async function saveQuoteToCareDB(quote_in) {
  try {
    let quote = removeImageFromItems(quote_in);
    console.log("saveQuoteToCareDB");
    console.log(quote);
    const response = await axios.post(`${CARE_MW_API_BASE_URL}/quote`, quote, {
      headers: {
        Authorization: `Bearer ${getCareAuthToken()}`,
        "Content-Type": "application/json", // Explicitly set Content-Type
      },
    });
    return response;
  } catch (error) {
    console.error("Error fetching quotes:", error);
    throw error;
  }
}
